import React, { Component } from "react";
import Alert from "react-s-alert";

import BasicTabs from "../../component/general/Tabs";
import LogEvents from "./tabs/LogEvents";
import Map from "./tabs/Map";
import Monitoring from "./tabs/Monitoring";
import Orders from "./tabs/Orders";
import Surveys from "./tabs/Surveys";
import Payments from "./tabs/Payments";
import Report from "./tabs/Report";
import Returns from "./tabs/Returns";
import Tasks from "./tabs/Tasks";
import { VISIT_PAGE } from "../../config/lang";

import { call } from "../../util/action";
import { visitOnePoint, timeSpentSingleVisit } from "../../util/formatter";
import { isImage } from "../../util/is-valid-url";
import { getStore } from "../../util/redux/store";
import { translate } from "../../util/util";

import "../../layout/leaflet.scss";

const me = getStore().getState().me;
class View extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: { lat: 50.4021379, lng: 30.3678885 },
      showMapItem: false,
      isApprovedTask: false,
    };

    this.showMap = this.showMap.bind(this);
    this.approveVisit = this.approveVisit.bind(this);
    this.rejectVisit = this.rejectVisit.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    if (id !== "new") {
      this.load(id);
    }
  }

  load = id => {
    call({ method: "GET", url: "visits/" + id + "/" }, item => {
      let location = {
        address: item.point.address,
        lat: item.point.location.latitude,
        lng: item.point.location.longitude,
      };

      this.setState({ item: item, location: location });
    });
  };

  getVisitInfo() {
    if (!this.state.item?.id) return;
    const visit = this.state.item ? visitOnePoint(this.state.item.id, this.state.item) : "";
    visit ? (visit.spentTime = timeSpentSingleVisit(this.state.item)) : null;
    visit ? (visit.taskStatus = this.state.item.is_approved) : null;
    return visit;
  }

  handleBackClick = () => {
    this.props.history.replace("/visit");
  };

  copyToClipboard = () => {
    const currentUrl = window.location.origin + this.props.location.pathname;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        Alert.success("URL copied to clipboard!");
      })
      .catch(err => {
        console.error("Error: ", err);
      });
  };

  showMap = () => {
    this.setState({ showMapItem: true });
  };

  approveVisit = () => {
    let { item } = this.state;
    if (item.is_approved) {
      Alert.warning(translate(VISIT_PAGE, "already_approve_visit_msg", me.language));
      return;
    }
    let body = { is_approved: true, approved_by: me.id };

    call({ method: "PATCH", url: "visits/" + item.id + "/", post: body }, r => {
      Alert.success(translate(VISIT_PAGE, "approve_visit_msg", me.language));
      this.setState({ isApprovedTask: true });
      this.load(item.id);
    });
  };

  rejectVisit = () => {
    let { item } = this.state;
    if (item.is_approved === false) {
      Alert.warning(translate(VISIT_PAGE, "already_reject_visit_msg", me.language));
      return;
    }
    let body = { is_approved: false, approved_by: me.id };

    call({ method: "PATCH", url: "visits/" + item.id + "/", post: body }, r => {
      Alert.success(translate(VISIT_PAGE, "reject_visit_msg", me.language));
      this.setState({ isApprovedTask: false });
      this.load(item.id);
    });
  };

  tabValidator = name => {
    let { item } = this.state;
    const visitTabTitles = [
      translate(VISIT_PAGE, "zvit_tab_name", me.language),
      translate(VISIT_PAGE, "task_tab_name", me.language),
      translate(VISIT_PAGE, "monitoring_tab_name", me.language),
      translate(VISIT_PAGE, "surveys_tab_name", me.language),
      translate(VISIT_PAGE, "log_tab_name", me.language),
    ];

    const visitComponents = [
      <Report key="report-visit-tab" data={item} />,
      <Tasks key="task-visit-tab" data={item} />,
      <Monitoring key="monitoring-visit-tab" data={item} />,
      <Surveys key="surveys-visit-tab" data={item} />,
      <LogEvents key="log-visit-tab" data={item} />,
    ];
    
    if (me.company?.features && me.company?.features.includes("orders")) {
      visitTabTitles.unshift(
        translate(VISIT_PAGE, "orders_tab_name", me.language),
        translate(VISIT_PAGE, "returns_tab_name", me.language),
        translate(VISIT_PAGE, "payments_tab_name", me.language)
      );

      visitComponents.unshift(
        <Orders key="orders-visit-tab" data={item} />,
        <Returns key="returns-visit-tab" data={item} />,
        <Payments key="payments-visit-tab" data={item} />
      );
    }
    return name === "label" ? visitTabTitles : visitComponents;
  };

  modalClose = () => this.setState({ showMapItem: false });

  render() {
    let { item } = this.state;
    const visit = this.getVisitInfo();

    const statusClass = visit?.taskStatus ? "vs-status--approved" : visit?.taskStatus === false ? "vs-status--rejected" : "vs-status--pending";
    const statusText = visit?.taskStatus
      ? translate(VISIT_PAGE, "approved_single_visit_name", me.language)
      : visit?.taskStatus === false
      ? translate(VISIT_PAGE, "no_approved_single_visit_name", me.language)
      : translate(VISIT_PAGE, "on_verification_single_visit_name", me.language);

    return (
      <div className="container-fluid visit-single-page vs-page">
        <div className="vs-top-bar">
          <button className="vs-back-btn" onClick={this.handleBackClick}>
            <span className="material-symbols-outlined">arrow_back</span>
            {translate(VISIT_PAGE, "back_to_btn_label", me.language)}
          </button>
        </div>

        <div className="vs-hero-card">
          <div className="vs-hero-left">
            <div className="vs-point-img-wrap">
              {isImage(item?.point?.image) ? (
                <img src={item.point.image} alt={visit?.name || ""} className="vs-point-img" />
              ) : (
                <div className="vs-point-img-fallback">
                  <span className="material-symbols-outlined">store</span>
                </div>
              )}
            </div>
            <div className="vs-point-info">
              <h2 className="vs-point-name">{visit ? visit.name : ""}</h2>
              <span className="vs-point-date">
                <span className="material-symbols-outlined">calendar_today</span>
                {visit ? visit.date : ""}
              </span>
              <div className="vs-hero-meta">
                {visit && <span className={`vs-status-chip ${statusClass}`}>{statusText}</span>}
                {visit?.spentTime && (
                  <span className="vs-time-chip">
                    <span className="material-symbols-outlined">schedule</span>
                    {visit.spentTime}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="vs-hero-right">
            <div className="vs-author-card">
              <div className="vs-author-avatar-wrap">
                {isImage(item?.user?.photo) ? (
                  <img src={item.user.photo} alt={visit?.author || ""} className="vs-author-avatar" />
                ) : (
                  <div className="vs-avatar-fallback">
                    <span className="material-symbols-outlined">person</span>
                  </div>
                )}
                <span className={`vs-author-status ${item?.user?.is_active ? "vs-author-status--active" : "vs-author-status--inactive"}`}></span>
              </div>
              <div className="vs-author-info">
                <span className="vs-author-name">{visit ? visit.author : "None"}</span>
                <span className="vs-author-role">{translate(VISIT_PAGE, "merchandiser", me.language)}</span>
                <span className="vs-author-phone">
                  <span className="material-symbols-outlined">phone</span>
                  {item?.user?.phone_number || "None"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="vs-actions-bar">
          <div className="vs-actions-left">
            <button className="vs-action-btn vs-action-btn--approve" onClick={this.approveVisit}>
              <span className="material-symbols-outlined">check_circle</span>
              {translate(VISIT_PAGE, "approv_btn", me.language)}
            </button>
            <button className="vs-action-btn vs-action-btn--reject" onClick={this.rejectVisit}>
              <span className="material-symbols-outlined">cancel</span>
              {translate(VISIT_PAGE, "reject_btn", me.language)}
            </button>
          </div>
          <div className="vs-actions-right">
            <button className="vs-icon-action" onClick={this.copyToClipboard} title="Copy link">
              <span className="material-symbols-outlined">content_copy</span>
            </button>
            <button className="vs-icon-action" onClick={this.showMap} title="Show on map">
              <span className="material-symbols-outlined">location_on</span>
            </button>
          </div>
        </div>

        <div className="vs-tabs-card">
          <div className="tabs-wrapper">
            {item ? <BasicTabs className="tabs-list" labels={this.tabValidator("label")} tabs={this.tabValidator("content")} /> : null}
          </div>
        </div>

        {this.state.showMapItem ? (
          <Map key="map-visit-tab" location={this.state.location} zoomLevel={12} isModal={this.state.showMapItem} modalClose={this.modalClose} />
        ) : null}
      </div>
    );
  }
}

export default View;